import { ComponentProps } from "react";
import classNames from "classnames";

export const Checkbox = ({ className, ...props }: Omit<ComponentProps<"input">, "type">) => {
  return (
    <label
      className={classNames("size-5 cursor-pointer", className, {
        relative: !className?.includes("absolute") && !className?.includes("relative"),
      })}
    >
      <input
        {...props}
        type="checkbox"
        className="peer size-5 cursor-pointer appearance-none rounded border border-neutral-20 bg-neutral-20 shadow transition-all checked:border-canvas-80 checked:bg-canvas-80 hover:shadow-md"
      />
      <span className="pointer-events-none absolute left-1 top-1 text-white opacity-0 peer-checked:opacity-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="size-3.5"
          viewBox="0 0 20 20"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          ></path>
        </svg>
      </span>
    </label>
  );
};
